import type React from "react"

import Link from "next/link"

import { asRoute } from "@/lib/routes"

/**
 * Use this component to create a Next.js `<Link />` for external URLs
 * that should not have the country code prepended.
 */
export const ExternalLink = ({
  children,
  href,
  ...props
}: {
  children?: React.ReactNode
  href: string
  className?: string
} & Omit<React.ComponentProps<typeof Link>, "href" | "children">) => {
  return (
    <Link href={asRoute(href)} {...props}>
      {children}
    </Link>
  )
}
